import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { JwtHelperService } from '@auth0/angular-jwt';
import { HttpClientService } from '../services/http-client.service';
import { ILoginModel } from './auth.model';

@Injectable()
export class AuthService {
    constructor(private _httpService: HttpClientService, private jwtHelper: JwtHelperService) { }

    loggedIn() {
        return !this.jwtHelper.isTokenExpired();
    }

    authentication(loginModel: ILoginModel): Observable<any> {
        return this._httpService.post<any, any>(
            '/admin/login', loginModel
        );
    }

    check(): Observable<boolean> {
        if (this.loggedIn()) {
            return of(true);
        }

        if (!this.loggedIn()) {
            return of(false);
        }

        return of(true);
    }

    postUserRegistration(userModel: any): Observable<any> {
        return this._httpService.post<any, any>(
            '/user', userModel
        );
    }
}